import type { ListAccess } from 'app/types/list-visibility'

export function isPersonalList(list: ListAccess): boolean {
  return list.visibility === `personal`
}

/** Only the list's creator can switch it between shared and personal. A list with no recorded creator stays as it is. */
export function canChangeVisibility(list: ListAccess, userId: string | undefined): boolean {
  return Boolean(list.createdByUserId) && list.createdByUserId === userId
}

/** A personal list is its creator's alone to delete; a shared one needs the role's `lists:delete-shared`. */
export function canDeleteList(list: ListAccess, userId: string | undefined, canDeleteShared: boolean): boolean {
  return isPersonalList(list) ? canChangeVisibility(list, userId) : canDeleteShared
}

/** The personal list marker's tooltip, and what list settings says once a list is made personal. */
export const PERSONAL_LIST_NOTE = `Only you can see this list`

export const SHARED_LIST_NOTE = `Your team can see this list`
